import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const switchingRoutes = {
  [ERouteMappingKeys.SWITCHING]: {
    id: "switching",
    path: "/switching",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Switching/Overview").then((p) => ({
          default: p.Overview,
        })),
      ),
      enterprise: lazy(() =>
        import("pages/Sections/Switching/Enterprise").then((p) => ({
          default: p.Enterprise,
        })),
      ),
      professional: lazy(() =>
        import("pages/Sections/Switching/Professional").then((p) => ({
          default: p.Professional,
        })),
      ),
      value: lazy(() =>
        import("pages/Sections/Switching/Standard").then((p) => ({
          default: p.Standard,
        })),
      ),
      compact: lazy(() =>
        import("pages/Sections/Switching/Compact").then((p) => ({
          default: p.Compact,
        })),
      ),
      wan: lazy(() =>
        import("pages/Sections/Switching/Wan").then((p) => ({
          default: p.Wan,
        })),
      ),
      "enterprise-av": lazy(() =>
        import("pages/Sections/Switching/EnterpriseAV").then((p) => ({
          default: p.EnterpriseAV,
        })),
      ),
    },
  },
};
